/* --------------------------------------------------
Import modules
-------------------------------------------------- */
import MagicScrolls from 'magic-scrolls';
/* --------------------------------------------------
Parallax
-------------------------------------------------- */

Meteora.each('[data-parallax]', function (section, index) {
  // Create a new MagicScrolls
  var magic = new MagicScrolls(section, {
    duration: 600
  }); // Find the parallax items

  var item = section.querySelector('[data-parallax-watch]');
  magic.parallax(item);
});